import React, { FC } from 'react';
import { WithStyle } from '../../utils/with-style';
import ButtonStyled from './button.styled';
import { ButtonProps } from './types';

export const Button: FC<ButtonProps> & WithStyle = ({ children, ...rest }) => {
  return (
    <ButtonStyled {...rest}>
      {Array.isArray(children)
        ? children.map((item, index) => (typeof item === 'string' ? <span key={index}>{item}</span> : item))
        : children}
    </ButtonStyled>
  );
};

Button.defaultProps = {
  type: 'button',
  $variant: 'solid',
  $size: 'sm',
  $color: 'primary',
  $fontWeight: 'semiBold',
  $fullWidth: false,
};

Button.displayName = 'Button';
Button.Style = ButtonStyled;
